import React, { useState, useEffect } from "react";
import Control from "react-leaflet-custom-control";
import PublicIcon from "@mui/icons-material/Public";
import CloseIcon from "@mui/icons-material/Close";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { useTranslation } from "react-i18next";

/**
 * Used to change the langugage of the application
 * @component
 * @category Components
 * @subcategory Map
 */

const LanguageSelector = () => {
  const [showLangugesContainer, toggle] = useState(false);
  const [value, setValue] = React.useState(localStorage.lang ? localStorage.lang : "bg");
  const { i18n } = useTranslation();
  const handleChange = (event) => {
    setValue(event.target.value);
    localStorage.lang =  event.target.value;
    i18n.changeLanguage(event.target.value);
  };

  const toggler = () => {
    toggle(!showLangugesContainer);
  };
  useEffect(() => {}, [showLangugesContainer]);

  return (
    <div>
      <Control position={"topleft"}>
        <div className='container map-selector' style={{ padding: 0, maxHeight: "50vh" }}>
          <div>
            <button
              className={showLangugesContainer ? "maplayers-button close-hover" : "maplayers-button"}
              onClick={() => toggler()}>
              {showLangugesContainer ? <CloseIcon /> : <PublicIcon />}
            </button>
          </div>
          {showLangugesContainer ? (
            <FormControl>
              <RadioGroup
                aria-labelledby='demo-controlled-radio-buttons-group'
                name='controlled-radio-buttons-group'
                value={value}
                className='lang-container'
                onChange={handleChange}>
                <FormControlLabel
                  value='bg'
                  control={<Radio />}
                  label={
                    <div className='lang-row'>
                      <div>БГ</div>
                      <img src='/flag-bg.webp' width={20} alt='' />
                    </div>
                  }
                />
                <FormControlLabel
                  value='en'
                  control={<Radio />}
                  label={
                    <div className='lang-row'>
                      <div>EN</div>
                      <img src='/flag-en.webp' width={20} alt='' />
                    </div>
                  }
                />
              </RadioGroup>
            </FormControl>
          ) : null}
        </div>
      </Control>
    </div>
  );
};
export default React.memo(LanguageSelector);
